import React from "react"

// import { ReactComponent as ScanSVG } from "assets/Icon/Scan Large.svg"
import { ReactComponent as IconSVG } from "assets/avtolog_icon_4.5.svg"

import "./AppPromo.sass"

const AppPromo = () => {
  return (
    <div className="AppPromo">
      <h3>Avtolog gre naprej</h3>
      <p>
        V veliko veselje nam je sporočiti, da je Avtolog postal del skupine
        AMZS, ki bo s svojim znanjem in izkušnjami omogočal nadaljni razvoj
        projekta.
      </p>
      <p>
        Skupaj bomo nadaljevali poslanstvo projekta in se še naprej trudili, da
        bodo podatki javno dostopni in da bomo skupaj ustvarjali varen in urejen
        avtomobilski trg. Odslej v modernejši podobi in po novem tudi z mobilno
        aplikacijo. Hvala za obisk.{" "}
      </p>
      <h4 className="caps">Mobilna aplikacija</h4>
      <div className="media-box">
        <IconSVG className="scan-large" />
        <p>
          Slikajte prometno dovoljenje s telefonom in samodejno bomo prepoznali
          VIN, ter vam naložili profil vozila!
        </p>
      </div>
      <p>
        <a
          href="/google-play-store"
          title="Prenesite aplikacijo avtolog iz Google Play Store"
        >
          <img
            className="store-image"
            src="/images/google-play-store.png"
            alt="Google Play Store"
          />
        </a>
        <a
          href="/apple-app-store"
          title="Prenesite aplikacijo avtolog iz Apple App Store"
        >
          <img
            className="store-image"
            src="/images/apple-app-store.png"
            alt="Apple App Store"
          />
        </a>
      </p>
    </div>
  )
}

export default AppPromo
